import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'contractorShort',
    standalone: true,
})
export class ContractorShortPipe implements PipeTransform {
    transform(contractor: string | null | undefined): string | null | undefined {
        return contractor?.replace(/gemeente /i, 'Gem. ').replace(/provincie /i, 'Prov. ');
    }
}
